import { useEffect, useMemo } from 'react'
import {
  storeSessionWithKey,
  getSessionWithKey,
} from '~/utils/sessionStorage/sessionStorageManager'

/**
 * Save the last state of a list. When click Back button in a form, use this to navigate to the list with state above.
 * @param {string} nav - navigation path on the nav bar
 * @param {boolean} autoUpdate - auto update path suffix to session storage
 * @returns {string}
 */
const useLastListState = (nav, autoUpdate = false) => {
  const { location } = window
  const pathSuffixs = useMemo(
    () => JSON.parse(getSessionWithKey('LIST_SUFFIX')) || {},
    [],
  )

  useEffect(() => {
    if (autoUpdate) {
      const currentPathSuffixs =
        JSON.parse(getSessionWithKey('LIST_SUFFIX')) || {}
      const newVal = location.search.concat(location.hash)
      if (
        (currentPathSuffixs[nav] || newVal) &&
        currentPathSuffixs[nav] !== newVal
      ) {
        const newPathSuffix = { ...currentPathSuffixs, [nav]: newVal }
        storeSessionWithKey('LIST_SUFFIX', JSON.stringify(newPathSuffix))
      }
    }
  }, [location.search, location.hash, nav, autoUpdate])

  return pathSuffixs[nav] || ''
}

export default useLastListState
